// Copyright (c) 2026 Finerty Data Ltd. All rights reserved.
//
// This file is part of proprietary software owned by Finerty Data Ltd.
// It is confidential and may not be copied, distributed, modified, or used,
// in whole or in part, without the prior written consent of Finerty Data Ltd.
//
// Author: Rafael Pereira Satyro

import type { Icon } from 'iconsax-react';

/**
 * Filled info-circle glyph (a thin ring with an "i") used as the trailing
 * field-hint affordance next to form labels. Matches the Figma "information"
 * icon; the design's full-area mask/clipPath are no-ops and are omitted. The
 * fill follows `color` (defaults to the design's #141414) so it inherits the
 * label colour when rendered via AppIcon with the default currentColor.
 */
const InfoCircleFilledIcon: Icon = ({ size = 20, color, variant: _variant, className, style, ...rest }) => {
  const fill = color || '#141414';
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
      {...rest}
    >
      <path
        d="M10.0007 1.04165C14.9423 1.04165 18.959 5.05831 18.959 9.99998C18.959 14.9416 14.9423 18.9583 10.0007 18.9583C5.05898 18.9583 1.04232 14.9416 1.04232 9.99998C1.04232 5.05831 5.05898 1.04165 10.0007 1.04165ZM10.0007 17.7083C14.2507 17.7083 17.709 14.25 17.709 9.99998C17.709 5.74998 14.2507 2.29165 10.0007 2.29165C5.75065 2.29165 2.29232 5.74998 2.29232 9.99998C2.29232 14.25 5.75065 17.7083 10.0007 17.7083Z"
        fill={fill}
      />
      <path
        d="M10 8.54165C10.3417 8.54165 10.625 8.82498 10.625 9.16665V13.3333C10.625 13.675 10.3417 13.9583 10 13.9583C9.65833 13.9583 9.375 13.675 9.375 13.3333V9.16665C9.375 8.82498 9.65833 8.54165 10 8.54165Z"
        fill={fill}
      />
      <path
        d="M10.0007 5.83256C10.109 5.83256 10.2173 5.85756 10.3173 5.89922C10.4173 5.94089 10.509 5.99922 10.5923 6.07422C10.6673 6.15756 10.7257 6.24089 10.7673 6.34922C10.809 6.44922 10.834 6.55756 10.834 6.66589C10.834 6.77422 10.809 6.88256 10.7673 6.98256C10.7257 7.08256 10.6673 7.17422 10.5923 7.25756C10.509 7.33256 10.4173 7.39089 10.3173 7.43256C10.1173 7.51589 9.88398 7.51589 9.68398 7.43256C9.58398 7.39089 9.49232 7.33256 9.40898 7.25756C9.33398 7.17422 9.27565 7.08256 9.23398 6.98256C9.19232 6.88256 9.16732 6.77422 9.16732 6.66589C9.16732 6.55756 9.19232 6.44922 9.23398 6.34922C9.27565 6.24089 9.33398 6.15756 9.40898 6.07422C9.49232 5.99922 9.58398 5.94089 9.68398 5.89922C9.78398 5.85756 9.89232 5.83256 10.0007 5.83256Z"
        fill={fill}
      />
    </svg>
  );
};

export { InfoCircleFilledIcon };
